import { render, staticRenderFns } from "./buyPanel.vue?vue&type=template&id=809eb4cc&"
import script from "./buyPanel.vue?vue&type=script&lang=ts&"
export * from "./buyPanel.vue?vue&type=script&lang=ts&"
import style0 from "./buyPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports